import _ from "lodash";
import React, { PureComponent, useMemo } from "react";
import classes from "./TagUnitV3.scss";
import classNames from "classnames";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import { useQuery } from "@apollo/client";
import I18nHOC from "UIComponents/I18nHOC";
import Loading from "UIComponents/Loading";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import {
  getCourseUnitQuery,
  getCourseUnitQueryV2,
} from "Post/modules/PostQuery";
import { updatePost } from "Post/modules/PostModule";
import { getFieldUids } from "modules/TaggableElementsUtils";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import moment from "moment";
import UnitList from "./UnitList";
import { Button, Modal, Tooltip, SearchInput } from "@toddle-edu/ds-web";
import DialogueBoxV3 from "UIComponents/DialogueBoxV3";
import { getCourseUnitFromCache } from "AppComponents/Post/modules/PostGraphqlHelpers";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";
import { getSelectedLearningCourseId } from "Teacher/routes/LearningCourse/modules/Utils";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";
import { colors } from "Constants";

import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import {
  getIsMultipleUnitTaggingEnabled,
  getIsNewGoalTaggingEnabled,
  isUnitPlanOrAssessmentTagged,
  getPostEntity,
  getIsNewGradingSetupEnabled,
} from "Post/utils";
import { getIsSubjectStandard } from "Teacher/routes/Courses/routes/Course/routes/ClassRoom/modules/utils";
import { pypElementMapping } from "Constants/plannerElementMappings";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";

const getStandardSetIds = (entities, isPYPCurriculum) => {
  const nestedStandardSetIds = _.map(entities, entity => {
    const standardsWrapper = _.get(entity, "fields", null);
    const standardEntity = _.find(standardsWrapper, field =>
      getIsSubjectStandard({ type: pypElementMapping[field.uid] })
    );
    if (
      standardEntity &&
      _.isArray(standardEntity.value) &&
      !_.isEmpty(standardEntity.value)
    ) {
      return _.map(
        isPYPCurriculum
          ? _.get(standardEntity, "resolvedMinimalTree.benchmarks", [])
          : _.get(standardEntity, "resolvedMinimalTree.nodes", []),
        "standardsWrapper.standardSet.id"
      );
    }
    return [];
  });
  // Flatten and remove duplicates/nulls
  return _.uniq(_.flatten(nestedStandardSetIds));
};

const styles = {
  modalHeader: {
    display: "flex",
    width: "100%",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalHeaderV2: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
  },
  modalBody: {
    overflowX: "hidden",
    overflowY: "auto",
    borderBottom: ` 1px solid ${colors.strokeTwo}`,
  },
  unitLabel: { color: "var(--text-secondary)" },
};

const BLANK_OBJECT = {};
const BLANK_ARRAY = [];

const FooterComponent = React.memo(props => {
  const { t, onBackClick } = props;

  return (
    <div className={classes.footerButtonContainer}>
      <Button
        size={"large"}
        onClick={onBackClick}
        variant="outlined-subtle"
        style={{ marginRight: "12px" }}
      >
        {t("common:previous")}
      </Button>
    </div>
  );
});

FooterComponent.displayName = "FooterComponent";

class TagUnit extends React.PureComponent {
  constructor(props) {
    super(props);
    this.resourceListRef = React.createRef(null);
    this.tagLearningGoalsButton = React.createRef(null);
    this.selectLearningGoalsButton = React.createRef(null);
    this.containerRef = React.createRef(null);
    const selectedUnitIds = getIsNewGoalTaggingEnabled()
      ? !_.isEmpty(props.postTaggedEntity)
        ? _.map(
            getPostEntity(props.postTaggedEntity, "UNIT_PLAN"),
            unit => unit.id
          )
        : []
      : props.unitPlanId;
    this.state = {
      currentSelectedUnitId: selectedUnitIds,
      selectedUnitId: selectedUnitIds,
      showDoneButton: false,
      selectFromAllPYP:
        props.unitPlanId ||
        (getIsNewGoalTaggingEnabled() &&
          isUnitPlanOrAssessmentTagged(props.postTaggedEntity))
          ? false
          : props.selectFromAllPYP,
      isTagLearningGoalsEnabled: false,
      showChangeUnitModal: false,
    };
  }

  stopPropagationAndPreventDefault = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  handleKeyDown = e => {
    const { key } = e;
    if (key === "Tab" && this.unitItems?.includes(document.activeElement)) {
      this.stopPropagationAndPreventDefault(e);
      if (this.state.isTagLearningGoalsEnabled) {
        this.tagLearningGoalsButton?.current?.focus();
      } else {
        this.selectLearningGoalsButton?.current?.focus();
      }
    }
  };

  getGoalsAndStudentCount = resource => {
    if (_.isArray(resource)) {
      return _.reduce(
        resource,
        (total, res) => total + this.getGoalsAndStudentCount(res),
        0
      );
    }
    return _.reduce(
      _.get(resource, "fields", []),
      (acc, element) => {
        const count = _.isArray(_.get(element, "value"))
          ? _.get(element, "value.length", 0)
          : 0;
        return acc + count;
      },
      0
    );
  };

  componentDidMount() {
    if (getIsNewGoalTaggingEnabled()) {
      const { updatePost, selectedElementsPYP } = this.props;
      updatePost({
        selectedElementsPYP: selectedElementsPYP,
      });
    }
    if (this.props?.unitPlanId) {
      this.enableTagLearningGoals(this.props.unitPlanId);
    } else if (getIsNewGoalTaggingEnabled() && this.state.selectedUnitId) {
      this.enableTagLearningGoals(this.state.selectedUnitId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { updatePost } = this.props;
    if (this.resourceListRef?.current) {
      const unitItems =
        Array.from(
          this.resourceListRef?.current?.querySelectorAll(
            ".UnitList__singleUnitItemContainer___jMgEY"
          )
        ) ?? [];

      this.unitItems = unitItems;
    }

    if (this.containerRef) {
      this.containerRef.current?.addEventListener(
        "keydown",
        this.handleKeyDown
      );
    }
    if (
      !getIsNewGoalTaggingEnabled() &&
      prevState.selectedUnitId !== this.state.selectedUnitId
    ) {
      this.enableTagLearningGoals(this.state.selectedUnitId);
    } else if (
      getIsNewGoalTaggingEnabled() &&
      (!_.isEqual(
        this.state.selectedUnitId,
        this.state.currentSelectedUnitId
      ) ||
        _.isEqual(
          this.state.selectedUnitId,
          this.state.currentSelectedUnitId
        ) ||
        (_.isEmpty(this.state.selectedUnitId) &&
          _.isEmpty(this.state.currentSelectedUnitId)))
    ) {
      updatePost({
        selectedElementsPYP: null,
      });
      this.enableTagLearningGoals(this.state.currentSelectedUnitId);
    }
  }

  onDoneClicked = () => {
    const { updatePost, screenPanelProps } = this.props;
    updatePost({
      postTaggedEntity: null,
      unitPlan: null,
      isResourceSkipped: false,
      resourceId: null,
      resourceType: null,
      resourceItem: undefined,
      elementPYP: undefined,
      selectedElementsPYP: undefined,
    });
    screenPanelProps.onCloseClick();
  };

  onNextClicked = (shouldGotoNextScreen = true) => {
    const {
      state: { selectedUnitId, currentSelectedUnitId, selectFromAllPYP },
      props: {
        unitPlanId: propUnitPlanId,
        screenPanelProps: { goToNextScreen, onCloseClick },
        unitPlans,
        originalUnitPlan,
        originalElementPYP,
        postTaggedEntity,
        elementPYP,
        setToastMsg,
        curriculumProgramType,
      },
    } = this;
    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();

    if (selectFromAllPYP) {
      const updatePostParams = {
        selectFromAllPYP,
        unitPlan: null,
        resourceId: null,
        resourceType: null,
        resourceItem: undefined,
      };

      if (
        _.isEmpty(propUnitPlanId) ||
        (isNewGoalTaggingEnabled &&
          !isUnitPlanOrAssessmentTagged(postTaggedEntity))
      ) {
        this.props.updatePost(updatePostParams);
      } else {
        this.props.updatePost({
          ...updatePostParams,
          elementPYP: null,
          selectedElementsPYP: null,
        });
        shouldGotoNextScreen ? goToNextScreen() : onCloseClick();
        return;
      }
    }

    const selectedUnitPlan = isNewGoalTaggingEnabled
      ? _.filter(unitPlans, item => _.includes(currentSelectedUnitId, item.id))
      : _.find(unitPlans, item => item.id == selectedUnitId);

    const updatedUnitPlan = isNewGoalTaggingEnabled
      ? _.map(selectedUnitPlan, unitPlan => {
          return {
            entityType: "UNIT_PLAN",
            entity: unitPlan,
            id: _.get(unitPlan, "id"),
          };
        })
      : [
          {
            entityType: "UNIT_PLAN",
            entity: selectedUnitPlan,
            id: selectedUnitId,
          },
        ];

    const updatedPostTaggedEntity = _.uniqBy(updatedUnitPlan, "id");
    const propUnitIds = _.map(
      getPostEntity(postTaggedEntity, "UNIT_PLAN"),
      unit => unit.id
    );
    const selectedUnitPlanIds = _.map(updatedPostTaggedEntity, unit =>
      _.get(unit, "id")
    );

    const isNewGradingSetupEnabled = getIsNewGradingSetupEnabled();
    const standardSetIds = isNewGradingSetupEnabled
      ? getStandardSetIds(
          _.map(updatedPostTaggedEntity, "entity"),
          curriculumProgramType === CURRICULUM_TYPE_PYP
        )
      : BLANK_ARRAY;

    if (
      (!_.isEmpty(propUnitPlanId) && propUnitPlanId == selectedUnitId) ||
      (!_.isEmpty(propUnitIds) && _.isEqual(propUnitIds, selectedUnitId))
    ) {
      if (isNewGoalTaggingEnabled) {
        this.props.updatePost({
          postTaggedEntity: updatedPostTaggedEntity,
          ...(isNewGradingSetupEnabled ? { standardSetIds } : {}),
          ...(!shouldGotoNextScreen
            ? { selectedElementsPYP: undefined }
            : BLANK_OBJECT),
        });
        this.setState({
          selectedUnitId: selectedUnitPlanIds,
        });
      } else {
        this.props.updatePost({
          unitPlan: selectedUnitPlan,
        });
      }
    } else {
      if (isNewGoalTaggingEnabled) {
        this.props.updatePost({
          postTaggedEntity: updatedPostTaggedEntity,
          resourceType: null,
          isResourceSkipped: false,
          elementPYP: _.isEqual(propUnitIds, currentSelectedUnitId)
            ? elementPYP
            : undefined,
          ...(isNewGradingSetupEnabled ? { standardSetIds } : {}),
          selectFromAllPYP: false,
          ...(!shouldGotoNextScreen
            ? { selectedElementsPYP: undefined }
            : BLANK_OBJECT),
        });
        if (!shouldGotoNextScreen) {
          setToastMsg({
            msg: "journal:count_of_units_tagged",
            locale_params: [
              {
                key: "count",
                value: _.size(currentSelectedUnitId),
                isPlainText: true,
              },
            ],
            type: "success",
          });
        }
        this.setState({
          selectedUnitId: selectedUnitPlanIds,
        });
      } else {
        this.props.updatePost({
          isResourceSkipped: false,
          resourceId: null,
          resourceType: null,
          resourceItem: undefined,
          elementPYP: _.isEqual(
            _.get(selectedUnitPlan, "id", null),
            _.get(originalUnitPlan, "id", undefined)
          )
            ? originalElementPYP
            : undefined,
          unitPlan: selectedUnitPlan,
        });
      }
    }
    shouldGotoNextScreen ? goToNextScreen() : onCloseClick();
  };

  onUnitClicked = unit => {
    const {
      selectedUnitId,
      currentSelectedUnitId,
      showChangeUnitModal,
    } = this.state;
    const { updatePost, elementPYP, userType } = this.props;
    const isMultipleUnitTagging = getIsMultipleUnitTaggingEnabled(userType);
    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
    let updatedUnitIds = [];
    if (isNewGoalTaggingEnabled) {
      if (isMultipleUnitTagging && _.includes(currentSelectedUnitId, unit.id)) {
        updatedUnitIds = _.filter(
          currentSelectedUnitId,
          unitId => unitId !== unit.id
        );
      } else if (isMultipleUnitTagging) {
        updatedUnitIds = [...currentSelectedUnitId, unit.id];
      } else {
        updatedUnitIds = [unit.id];
      }
    }
    if (
      isNewGoalTaggingEnabled &&
      !_.isEmpty(selectedUnitId) &&
      !showChangeUnitModal &&
      _.includes(selectedUnitId, unit.id) &&
      !_.includes(updatedUnitIds, unit.id) &&
      !_.isEmpty(elementPYP)
    ) {
      this.setState({
        showChangeUnitModal: true,
        modalUnit: unit,
      });
    } else {
      updatePost({ selectedElementsPYP: null });
      this.setState({
        selectedUnitId: unit.id,
        currentSelectedUnitId: isNewGoalTaggingEnabled
          ? updatedUnitIds
          : unit.id,
        showDoneButton: !_.isEmpty(this.props.unitPlanId),
        selectFromAllPYP: false,
      });
    }
  };

  onConfirmUnitChange = () => {
    const { updatePost } = this.props;
    const { modalUnit } = this.state;
    this.setState({
      showChangeUnitModal: false,
      ...(!getIsNewGoalTaggingEnabled()
        ? {
            selectedUnitId: this.props.unitPlanId,
            showDoneButton: !_.isEmpty(this.props.unitPlanId),
            selectFromAllPYP: false,
          }
        : BLANK_OBJECT),
    });
    updatePost({ elementPYP: [] });
    this.onUnitClicked(modalUnit);
  };

  enableTagLearningGoals = unitPlanId => {
    const unitPlan = getIsNewGoalTaggingEnabled()
      ? _.filter(this.props.unitPlans, item => _.includes(unitPlanId, item.id))
      : _.find(this.props.unitPlans, item => item.id == unitPlanId);
    this.setState({
      isTagLearningGoalsEnabled: this.getGoalsAndStudentCount(unitPlan) > 0,
    });
  };

  onSelectFromAllPYP = () => {
    const {
      state: { selectFromAllPYP },
    } = this;

    const { userType } = this.props;

    this.setState({
      selectFromAllPYP: !selectFromAllPYP,
      selectedUnitId: getIsMultipleUnitTaggingEnabled(userType) ? [] : null,
    });
  };

  render() {
    const {
      props: {
        screenPanelProps,
        unitPlans,
        isLoading,
        isData,
        t,
        curriculumProgramType,
        searchText,
        updateSearchText,
        networkStatus,
        userType,
      },
      state: {
        currentSelectedUnitId,
        selectedUnitId,
        selectFromAllPYP,
        isTagLearningGoalsEnabled,
      },
    } = this;

    const { onCloseClick } = screenPanelProps;

    const getTagLearningGoalsTooltip = () => {
      if (
        getIsMultipleUnitTaggingEnabled(userType)
          ? _.isEmpty(selectedUnitId)
          : !selectedUnitId
      ) {
        return t("journal:select_le_to_tag_goals");
      } else if (!isTagLearningGoalsEnabled) {
        return t("journal:no_learning_goals_tagged_to_unit");
      }
    };

    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();
    const onCloseWarningModal = () => {
      this.setState({
        showChangeUnitModal: false,
      });
    };

    const onCloseUnitModal = () => {
      const { postTaggedEntity, updatePost } = this.props;
      if (
        isNewGoalTaggingEnabled &&
        isUnitPlanOrAssessmentTagged(postTaggedEntity)
      ) {
        updatePost({ selectedElementsPYP: undefined });
      }
      onCloseClick();
    };
    const onSelectUnit = () => {
      this.onNextClicked(false);
    };

    const modalButtonProps = {
      button2Props: {
        variant: "primary",
        size: "medium",
      },
      button1Props: {
        variant: "neutral",
        size: "medium",
        testId: "journal-postcreation-cancel",
        type: "outlined",
      },
    };

    const modalFooterClass = classNames({
      [classes.footer]: true,
      [classes.footerV2]:
        isNewGoalTaggingEnabled && _.size(currentSelectedUnitId) > 0,
    });

    return (
      <>
        <Modal
          dsVersion={"2.0"}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          hasOverlay={true}
          onClose={onCloseUnitModal}
          width="90%"
          height="90%"
          isCloseable={true}
          isBodyScrollable={false}
        >
          <Modal.Header
            classNamer={
              isNewGoalTaggingEnabled
                ? classes.modalContainerV2
                : classes.modalContainer
            }
            hasSeparator={true}
          >
            {isNewGoalTaggingEnabled ? (
              <div style={styles.modalHeaderV2}>
                <div className={"heading-4"}>
                  {t("journal:tag_learning_elements")}
                </div>
                <label className="text-label-l" style={styles.unitLabel}>
                  {t("common:unit")}
                </label>
              </div>
            ) : null}
            {!isNewGoalTaggingEnabled ? (
              <div style={styles.modalHeader}>
                <div className={"heading-4"}>{t("journal:select_a_unit")}</div>
              </div>
            ) : null}
            {isNewGoalTaggingEnabled ? (
              <div className={classes.searchContainer}>
                <div className={classes.searchBar}>
                  <SearchInput
                    dsVersion="2.0"
                    id="search-unit"
                    placeholder={t("common:search_placeholder")}
                    focusSearchBySlash={true}
                    value={searchText}
                    onChange={updateSearchText}
                    size={"large"}
                  />
                </div>
              </div>
            ) : null}
          </Modal.Header>
          <Modal.Body style={styles.modalBody}>
            {(isData || !_.isEmpty(_.get(this.props, "searchText", ""))) &&
              !isNewGoalTaggingEnabled && (
                <div className={classes.filterContainer}>
                  <SearchInput
                    dsVersion="2.0"
                    id="search-unit"
                    placeholder={t("common:search_placeholder")}
                    value={searchText}
                    onChange={updateSearchText}
                    size={"large"}
                    testId={"journal-postcreation-tagunit"}
                    focusSearchBySlash={true}
                  />
                </div>
              )}
            <div className={classes.container} ref={this.containerRef}>
              <UnitList
                selectedUnitId={
                  isNewGoalTaggingEnabled
                    ? currentSelectedUnitId
                    : selectedUnitId
                }
                selectFromAllPYP={selectFromAllPYP}
                searchText={searchText}
                unitPlans={unitPlans}
                onItemClicked={this.onUnitClicked}
                isData={isData}
                isLoading={isLoading}
                showLoaderBar={false}
                onSelectFromAllPYP={this.onSelectFromAllPYP}
                curriculumProgramType={curriculumProgramType}
                resourceListRef={this.resourceListRef}
                selectLearningGoalsButton={this.selectLearningGoalsButton}
                tagLearningGoalsButton={this.tagLearningGoalsButton}
                postTaggedEntity={this.props.postTaggedEntity}
                selectedEntityIndex={this.props.selectedEntityIndex}
                userType={userType}
              />
            </div>
            {networkStatus == 3 ? (
              <Loading loadingStyle={{ width: 36, height: 36 }} />
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <div className={modalFooterClass}>
              {isNewGoalTaggingEnabled && _.size(currentSelectedUnitId) > 0 ? (
                <label className="text-label">
                  {t("journal:count_of_units_selected", {
                    count: _.size(currentSelectedUnitId),
                  })}
                </label>
              ) : null}
              <div className={classes.footerContainer}>
                <ConditionalWrapper
                  type="wrapperAsElement"
                  wrapper={
                    <Tooltip
                      tooltip={getTagLearningGoalsTooltip()}
                      placement={"top"}
                    />
                  }
                  condition={
                    (!selectedUnitId || !isTagLearningGoalsEnabled) &&
                    _.size(unitPlans)
                  }
                >
                  <Button
                    type={"outlined"}
                    variant="neutral"
                    dsVersion={"2.0"}
                    disabled={!isTagLearningGoalsEnabled}
                    onClick={this.onNextClicked}
                    size="medium"
                    testId="journal-postcreation-taglearninggoals"
                    ref={this.tagLearningGoalsButton}
                  >
                    {t("journal:tag_pyp_elements")}
                  </Button>
                </ConditionalWrapper>
                <Button
                  variant={"progressive"}
                  type="fill"
                  dsVersion="2.0"
                  size="medium"
                  onClick={onSelectUnit}
                  disabled={
                    isNewGoalTaggingEnabled
                      ? _.isEmpty(currentSelectedUnitId)
                      : !selectedUnitId
                  }
                  ref={this.selectLearningGoalsButton}
                  testId="journal-postcreation-selectunit"
                >
                  {isNewGoalTaggingEnabled
                    ? t("journal:select_and_add")
                    : t("common:select")}
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
        {this.state.showChangeUnitModal ? (
          <DialogueBoxV3
            modalTitle={t("journal:remove_unit")}
            showModal={true}
            onClickButton1={onCloseWarningModal}
            onClickButton2={this.onConfirmUnitChange}
            modalBody={t("journal:removing_unit_warning")}
            toggleDialogueBoxDisplay={onCloseWarningModal}
            button2={t("journal:remove_unit")}
            button1={t("common:cancel")}
            button2Props={modalButtonProps.button2Props}
            button1Props={modalButtonProps.button1Props}
          />
        ) : null}
      </>
    );
  }
}

const mapActionCreators = {
  updatePost,
  setToastMsg,
};

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const courseIdFromParent = _.get(
    ownProps,
    "screenPanelProps.postDetails.courseId"
  );
  const courseId = courseIdFromParent
    ? courseIdFromParent
    : state.teacher.selected_class.selected_course ||
      _.get(state, "post.postDetails.course.id", null);
  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const {
    unitPlan = {},
    selectFromAllPYP,
    elementPYP = [],
    originalUnitPlan = {},
    originalElementPYP = [],
    postTaggedEntity = [],
    selectedEntityIndex,
    selectedElementsPYP,
  } = state.post.postDetails;

  let selectFromAllPYPNew = selectFromAllPYP;
  if (
    !selectFromAllPYP &&
    !_.isEmpty(elementPYP) &&
    _.isEmpty(unitPlan) &&
    (getIsNewGoalTaggingEnabled()
      ? isUnitPlanOrAssessmentTagged(postTaggedEntity)
      : true)
  )
    selectFromAllPYPNew = true;

  const academicYearId = getSelectedAcademicYearId(state);
  const courseGradeFilters = {
    academicYearId,
  };

  const courseDetails = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters,
  });
  const currentAcademicYear = _.get(courseDetails, "academicYear", null);
  const startDate = moment(_.get(currentAcademicYear, "startDate", "")).format(
    "YYYY-MM-DD"
  );
  const endDate = moment(_.get(currentAcademicYear, "endDate", "")).format(
    "YYYY-MM-DD"
  );
  const userType = userInfo.user_type;
  const uids = getFieldUids({ curriculumProgramType });
  const selectedEntity = _.get(postTaggedEntity, selectedEntityIndex);
  const isLearningCourseEnabled =
    getIsLearningCoursesEnabled(state) && _.isEqual(userType, "staff");
  const learningCourseIdFromPost = _.get(
    state,
    "post.postDetails.course.learningCourse[0].id"
  );
  const learningCourseId =
    getSelectedLearningCourseId(state) || learningCourseIdFromPost;

  return {
    endDate,
    startDate,
    mode: state.post.postCreationMode,
    unitPlanId: getIsNewGoalTaggingEnabled()
      ? _.get(selectedEntity, "entity.id", null)
      : _.get(unitPlan, "id", null),
    templateId: getIsNewGoalTaggingEnabled()
      ? _.get(selectedEntity, "entity.templateId", null)
      : _.get(unitPlan, "templateId", ""),
    courseId,
    isLearningCourseEnabled,
    learningCourseId,
    unitPlan,
    originalUnitPlan,
    elementPYP,
    originalElementPYP,
    selectFromAllPYP: selectFromAllPYPNew,
    curriculumProgramType,
    userId: userInfo.id,
    userType,
    t: ownProps.t,
    filters: {
      searchText: _.get(ownProps, "searchText", ""),
      ...(userType === "student" ? { studentIds: [userInfo.id] } : {}),
    },
    uids,
    postTaggedEntity,
    selectedEntityIndex,
    selectedElementsPYP,
  };
};

const TagUnitWithV1HOC = compose(
  graphql(getCourseUnitQuery, {
    name: "getCourseUnit",
    skip: ({ learningCourseId }) => learningCourseId,
    options: ({ courseId, filters, uids }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        filters: filters,
        id: courseId,
        uids,
      },
    }),
    props({
      getCourseUnit,
      ownProps: { unitPlan, courseId, filters, uids, postTaggedEntity },
    }) {
      const courseDetail = getCourseUnitFromCache({
        filters: filters,
        id: courseId,
        uids,
      });
      const unitPlans = _.filter(
        _.map(_.get(courseDetail, "flatUnitPlans.edges", BLANK_ARRAY), "node"),
        item => !_.isEmpty(item)
      );

      const taggedUnitPlans = getPostEntity(postTaggedEntity, "UNIT_PLAN");
      const updatedUnitPlans = !getIsNewGoalTaggingEnabled()
        ? !_.isEmpty(unitPlan)
          ? _.uniqBy([unitPlan, ...unitPlans], "id")
          : unitPlans
        : _.uniqBy([...taggedUnitPlans, ...unitPlans], "id");
      return {
        unitPlans: updatedUnitPlans,
        isData: !_.isEmpty(courseDetail),
        isLoading:
          getCourseUnit["networkStatus"] == 1 ||
          getCourseUnit["networkStatus"] == 2,
        networkStatus: getCourseUnit["networkStatus"],
      };
    },
  })
)(TagUnit);

const TagUnitWithLearningCourseQuery = props => {
  const { learningCourseId, filters, uids, unitPlan, postTaggedEntity } = props;
  const skip = _.isNil(learningCourseId) || _.isEmpty(learningCourseId);
  const learningCourseUnitsQueryResult = useQuery(getCourseUnitQueryV2, {
    variables: { filters, id: learningCourseId, uids },
    fetchPolicy: "cache-and-network",
    skip,
  });
  const data = _.get(learningCourseUnitsQueryResult, "data");
  const networkStatus = _.get(learningCourseUnitsQueryResult, "networkStatus");

  const learningCourseProps = useMemo(() => {
    if (skip) return null;
    const courseDetail = _.get(data, "node", BLANK_OBJECT);
    const unitPlans = _.filter(
      _.map(_.get(courseDetail, "unitPlans.edges", BLANK_ARRAY), "node"),
      item => !_.isEmpty(item)
    );
    const taggedUnitPlans = getPostEntity(postTaggedEntity, "UNIT_PLAN");
    const updatedUnitPlans = !getIsNewGoalTaggingEnabled()
      ? !_.isEmpty(unitPlan)
        ? _.uniqBy([unitPlan, ...unitPlans], "id")
        : unitPlans
      : _.uniqBy([...taggedUnitPlans, ...unitPlans], "id");
    return {
      unitPlans: updatedUnitPlans,
      isData: !_.isEmpty(courseDetail),
      isLoading: networkStatus == 1 || networkStatus == 2,
      networkStatus,
    };
  }, [skip, data, networkStatus, unitPlan, postTaggedEntity]);

  return <TagUnitWithV1HOC {...props} {...(learningCourseProps || {})} />;
};

const TagUnitWithHOC = compose(connect(mapStateToProps, mapActionCreators))(
  TagUnitWithLearningCourseQuery
);

class TagUnitWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
  }

  updateSearchText = value => {
    this.setState({ searchText: value });
  };

  render() {
    return (
      <TagUnitWithHOC
        {...this.props}
        searchText={this.state.searchText}
        updateSearchText={this.updateSearchText}
      />
    );
  }
}

export default compose(I18nHOC({ resource: ["common", "journal"] }))(
  TagUnitWrapper
);
